import React from "react"
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip"
import { styled } from "@mui/material/styles"
import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"

const CustomTooltip = styled(({ className, ...props }: any) => <Tooltip {...props} classes={{ popper: className }} />)({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "white",
        color: "black",
        boxShadow: "0px 3px 5px rgba(0,0,0,0.2)",
        fontSize: 14,
        lineHeight: "18px",
        padding: "20px",
    },
})

const MarkdownTooltip = ({ title, children, ...props }: any) => {
    return (
        <CustomTooltip title={<ReactMarkdown remarkPlugins={[remarkGfm]}>{title}</ReactMarkdown>} {...props}>
            {children}
        </CustomTooltip>
    )
}

export default MarkdownTooltip
